<template>
  <section class="height-100-p margin-t-20" id="details-search-summary-section">
    <el-row>
      <el-col>
        <el-form
          id="details-search-section-form"
          class="search-section-form"
          :model="filters"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col class="details-total-units" :span="2">
              <span class="el-pagination__total" slot>
                <span class="el-pagination__title" slot>{{ $t('customerService.shipment.totalUnits') }}</span>
                {{ shipment.currentDetail.details.units }}
              </span>
            </el-col>
            <el-col class="show-cancelled" :span="10">
              <el-form-item :label="$t('customerService.shipment.showCancelled')">
                <el-select
                  v-model="filters.showCancelled"
                  id="searchForm-status"
                  ref="filter-status"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="option in shipmentDetailStatusOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="text-align-end">
              <add-detail class="margin-r-10" v-if="!splittingShipment" :shipment-id="this.shipmentId" @detailAdded="handleSearch"></add-detail>
              <span v-if="canSplitShipment()">
                <el-button id="btn-split-shipment" class="button-action-default" v-if="!splittingShipment" @click="splittingShipment = true" size="mini" type="success" plain>{{ $t('customerService.shipment.splitShipment') }}</el-button>
                <div class="flex-reverse-direction">
                  <el-button id="btn-submit-split-shipment" v-if="splittingShipment" type="primary" @click="handleSplitShipment" size="mini">{{ $t('customerService.shipment.splitShipment') }}</el-button>
                  <el-button id="btn-cancel-split-shipment" class="margin-r-10" v-if="splittingShipment" type="default" @click="cancelSplitShipment" size="mini">{{ $t('common.cancel') }}</el-button>
                </div>
              </span>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-form :model="editForm" :rules="editFormRules" ref="editForm">
      <el-table
        :data="shipment.currentDetail.details.list"
        v-loading="shipment.currentDetail.details.loadingSearch"
        id="rates-shipment-data-list"
        size="mini"
        tooltip-effect="dark"
        sortable
        class="dark-blue-table shipment-header-vertical-center"
        :empty-text="$t('common.notAbleToFindRecords')"
        stripe
        ref="shipmentDetailSummaryTable"
        @select="handleSelection"
        @select-all="handleSelection"
      >
        <el-table-column :label="$t('invoices.flower.numberOfUnits')" :min-width="6" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-form-item prop="numberUnits">
                <el-input-number
                  v-model="editForm.numberUnits"
                  v-numeric-validation
                  :precision="0"
                  :min="1"
                  :max="999"
                  @focus="$event.target.select()"
                  @change="editForm.mustReRate = true"
                  :maxlength="3"
                  :controls="false"
                  size="mini"
                  class="inline-input width-100p"
                  id="row-number-units"
                ></el-input-number>
              </el-form-item>
            </template>
            <span v-else>{{ scope.row.numberUnits }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.flower.length')" :min-width="5" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-form-item prop="length">
                <el-input-number
                  v-model="editForm.length"
                  v-numeric-validation
                  :controls="false"
                  :precision="2"
                  :min="0"
                  :max="999.99"
                  @focus="$event.target.select()"
                  @change="editForm.mustReRate = true"
                  size="mini"
                  class="inline-input width-100p"
                  id="row-length"
                  ref="row-length"
                ></el-input-number>
              </el-form-item>
            </template>
            <span v-else>{{scope.row.length}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.flower.width')" :min-width="4" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-form-item prop="width">
                <el-input-number
                  v-model="editForm.width"
                  v-numeric-validation
                  :controls="false"
                  :precision="2"
                  :min="0"
                  :max="999.99"
                  @focus="$event.target.select()"
                  @change="editForm.mustReRate = true"
                  size="mini"
                  class="inline-input width-100p"
                  id="row-width"
                  ref="row-width"
                ></el-input-number>
              </el-form-item>
            </template>
            <span v-else>{{scope.row.width}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.flower.height')" :min-width="6" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-form-item prop="height">
                <el-input-number
                  v-model="editForm.height"
                  v-numeric-validation
                  :controls="false"
                  :precision="2"
                  :min="0"
                  :max="999.99"
                  @focus="$event.target.select()"
                  @change="editForm.mustReRate = true"
                  size="mini"
                  class="inline-input width-100p"
                  id="row-height"
                  ref="row-height"
                ></el-input-number>
              </el-form-item>
            </template>
            <span v-else>{{scope.row.height}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('invoices.flower.totalCubes')" :min-width="6" align="center">
           <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <span>{{ calculateCubes }}</span>
          </template>
            <span v-else>{{ scope.row.totalCubes.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="5"
          :label="$t('door.status')"
          align="center"
          class-name="fixed-width"
        >
          <template slot-scope="scope">
            <span>{{ getDetailStatusLabel(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="10"
          :label="$t('customerService.shipment.cancellationReason')"
          align="center"
          class-name="fixed-width"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cancelReasonName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="5"
          :label="$t('invoices.flower.productCode')"
          align="center"
          class-name="fixed-width"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-form-item prop="productCode">
                <autocomplete
                  :model.sync="editForm.productCode"
                  :modelAdditional.sync="editForm.productDescription"
                  popperAppendToBody
                  :strict="false"
                  :url="urlProduct"
                  labelField="description"
                  labelFieldLastWithDash="code"
                  labelfieldSelected="code"
                  valueField="code"
                  valueFieldAdditional="description"
                  :maxlength="5"
                  id="row-productCode"
                  ref="row-productCode"
                />
              </el-form-item>
            </template>
            <span v-else>{{scope.row.productCode}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="5"
          :label="$t('customerService.shipment.productDescription')"
          align="center"
          class-name="fixed-width"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-form-item prop="productDescription">
                <el-input
                  v-model="editForm.productDescription"
                  v-alphanumeric-validation
                  clearable
                  maxlength="30"
                  size="mini"
                  class="inline-input"
                  id="row-product-description"
                  ref="row-product-description"
                ></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.productDescription"
                placement="top"
              >
                <span>{{ scope.row.productDescription }}</span>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="5"
          :label="$t('invoices.flower.poNumber')"
          align="center"
          class-name="fixed-width"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-form-item prop="poNumber">
                <el-input
                  v-model="editForm.poNumber"
                  v-alphanumeric-validation
                  clearable
                  maxlength="25"
                  size="mini"
                  class="inline-input"
                  id="row-po-number"
                  ref="row-po-number"
                ></el-input>
              </el-form-item>
            </template>
            <template v-else>
              <el-tooltip class="item" effect="dark" :content="scope.row.poNumber" placement="top">
                <span>{{ scope.row.poNumber }}</span>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!splittingShipment"
          width="70"
          :label="$t('common.options')"
          align="center"
          class-name="fixed-width"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="showEditButton(scope.row)"
              class="item el-icon-edit-tooltip"
              effect="dark"
              :enterable="false"
              :content="$t('customerService.shipment.detailEdit')"
              placement="top-start"
            >
              <i class="el-icon-edit icon-action" @click="handleEdit(scope.row)"></i>
            </el-tooltip>
            <template v-else-if="scope.row.edit">
              <el-button icon="el-icon-success" circle size="mini" @click="handleUpdate(scope.row)"></el-button>
              <el-button
                icon="el-icon-circle-close"
                circle
                size="mini"
                @click="cancelEdit(scope.row)"
              ></el-button>
            </template>
            <shipment-detail-cancel-button
              v-if="!shipment.isEditingDetails"
              :shipmentId="shipmentId"
              :shipmentStatus="shipmentStatus"
              :shipmentDetail="scope.row"
            />
            <split-detail
              v-if="!shipment.isEditingDetails"
              :shipmentId="shipmentId"
              :shipmentStatus="shipmentStatus"
              :shipmentDetail="scope.row"
              @detailSplit="handleSearch"
            ></split-detail>
          </template>
        </el-table-column>
        <el-table-column
          v-for="i in (splittingShipment)? [1]: []" :key="i"
          type="selection"
          align="center"
          width="70"
        ></el-table-column>
      </el-table>
    </el-form>
    <div class="pagination-footer">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('warehouse.orderEntry.totalShipments') }}</span>
        {{ shipment.currentDetail.details.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-size="filters.rows"
        :current-page.sync="filters.page"
        @current-change="handleSearchChangePage"
        :total="shipment.currentDetail.details.total"
        layout="sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import AddDetail from '@/views/customerCenter/shipments/components/AddDetail';
import SplitDetail from '@/views/customerCenter/shipments/components/SplitDetail';
import ShipmentDetailCancelButton from './ShipmentDetailCancelButton';

export default {
  name: 'DetailsSummarySection',
  components: {
    SplitDetail,
    AddDetail,
    ShipmentDetailCancelButton,
    Autocomplete
  },
  computed: {
    ...mapGetters(['shipment']),
    calculateCubes() {
      const {
        length, height, width, numberUnits
      } = this.editForm;

      return (((length * width * height) / 1728) * numberUnits).toFixed(2);
    },
    shipmentDetailStatusOptions() {
      return [
        { label: this.$t('common.yes'), value: 1 },
        { label: this.$t('common.no'), value: 0 }
      ];
    },
    urlProduct() {
      return apiConstants.END_POINTS.PRODUCT_SEARCH;
    }
  },
  props: {
    shipmentId: {
      type: Number,
      default: null
    },
    shipmentStatus: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      searching: false,
      filters: {
        showCancelled: 0,
        shipmentId: this.shipmentId,
        page: constants.TABLES.DEFAULT_PAGE,
        rows: constants.TABLES.DEFAULT_LIMIT,
        pageResults: true
      },
      editForm: {
        id: null,
        numberUnits: null,
        length: null,
        width: null,
        height: null,
        cubes: null,
        totalCubes: null,
        productCode: '',
        productDescription: '',
        poNumber: '',
        mustReRate: null
      },
      editFormRules: {
        length: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.lengthRequired'),
            trigger: 'blur'
          }
        ],
        width: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.widthRequired'),
            trigger: 'blur'
          }
        ],
        height: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.heightRequired'),
            trigger: 'blur'
          }
        ],
        numberUnits: [
          {
            required: true,
            message: this.$t(
              'customerService.shipment.error.numberUnitsRequired'
            ),
            trigger: 'blur'
          }
        ],
        productCode: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.productRequired'),
            trigger: 'blur'
          }
        ]
      },
      splittingShipment: false,
      selectedShipmentDetails: [],
    };
  },
  watch: {
    'shipment.currentDetail.details.list': function watchLoadList() {
      if (this.splittingShipment) {
        this.$nextTick(() => {
          this.shipment.currentDetail.details.list.forEach((row) => {
            if (this.selectedShipmentDetails[this.filters.page - 1]
                && this.selectedShipmentDetails[this.filters.page - 1].includes(row.id)) {
              this.$refs.shipmentDetailSummaryTable.toggleRowSelection(row, true);
            }
          });
        });
      }
    }
  },
  methods: {
    getDetailStatusLabel(value) {
      return constants.SHIPMENT_DETAILS_STATUS.find(
        status => status.value === value
      ).label;
    },
    handleSearchChangeLimit(data) {
      this.filters.rows = data;
      this.filters.page = constants.TABLES.DEFAULT_PAGE;

      if (this.splittingShipment) {
        this.selectedShipmentDetails = [];
        this.$refs.shipmentDetailSummaryTable.clearSelection();
      }

      this.handleSearch();
    },
    handleSearchChangePage(data) {
      this.filters.page = data;
      this.handleSearch();
    },
    handleSearch() {
      this.filters.shipmentId = this.shipmentId;
      this.$store.dispatch('shipment/searchDetails', this.filters);
      this.$store.dispatch('shipment/searchHeader', this.shipmentId);
    },
    showEditButton(row) {
      const hasShipmentClosedOrCancelled = this.shipmentStatus === constants.SHIPMENT.STATUS[5].value || this.shipmentStatus === constants.SHIPMENT.STATUS[6].value;
      return (
        this.$can(this.permissions.BILLING.EDIT_SHIPMENT)
        && !this.shipment.isEditingDetails && row.active
        && !hasShipmentClosedOrCancelled
      );
    },
    handleEdit(row) {
      this.$store.dispatch('shipment/setEditingDetails', true);
      row.edit = true;
      this.editForm.id = row.id;
      this.editForm.numberUnits = row.numberUnits;
      this.editForm.length = row.length;
      this.editForm.width = row.width;
      this.editForm.height = row.height;
      this.editForm.cubes = row.cubes;
      this.editForm.totalCubes = row.totalCubes;
      this.editForm.productCode = row.productCode;
      this.editForm.productDescription = row.productDescription;
      this.editForm.poNumber = row.poNumber;
      this.editForm.mustReRate = false;
      this.$nextTick(() => {
        this.$refs['row-productCode'].setLocalModel(row.productCode);
      });
    },
    clearEdit() {
      this.$store.dispatch('shipment/setEditingDetails', false);
      this.$refs.editForm.resetFields();
      this.$refs['row-productCode'].clearLocalModel();
    },
    cancelEdit(row) {
      row.edit = false;
      this.clearEdit();
    },
    handleUpdate() {
      this.$refs.editForm.validate(async (valid, validationsErrors) => {
        if (valid) {
          if (this.editForm.mustReRate && this.shipmentStatus !== constants.SHIPMENT.STATUS[1].value) {
            const confirmReRate = await this.$confirm(
              this.$t('customerService.shipment.reRateUpdateDetailConfirm'),
              { confirmButtonText: this.$t('Ok'), dangerouslyUseHTMLString: true }
            ).catch(() => {});

            if (confirmReRate) {
              await this.sendUpdate();
            }
          } else {
            this.editForm.mustReRate = false;
            await this.sendUpdate();
          }
        } else {
          let errorMessage = '';
          Object.keys(validationsErrors).forEach((key) => {
            validationsErrors[key].forEach((validation) => {
              errorMessage += `${validation.message}. `;
            });
          });
          this.$message.warning(errorMessage);
        }
      });
    },
    sendUpdate() {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store
        .dispatch('shipment/updateDetail', {
          shipmentId: this.shipmentId,
          shipmentDetailId: this.editForm.id,
          detailToUpdate: this.editForm
        })
        .then((response) => {
          loading.close();
          this.$message.success(response.message);
          this.clearEdit();
          this.handleSearch();
        })
        .catch(() => {
          loading.close();
        });
    },
    setShowCancelled(showCancelled) {
      this.filters.showCancelled = showCancelled;
    },
    canSplitShipment() {
      const hasShipmentClosedOrCancelled = this.shipmentStatus === constants.SHIPMENT.STATUS[5].value
        || this.shipmentStatus === constants.SHIPMENT.STATUS[6].value;
      return (
        this.$can(this.permissions.BILLING.EDIT_SHIPMENT)
        && !this.shipment.isEditingDetails
        && !hasShipmentClosedOrCancelled
        && this.shipment.currentDetail.details.list.length > 1
      );
    },
    handleSelection(selection) {
      this.selectedShipmentDetails[this.filters.page - 1] = [...selection.map(row => row.id)];
    },
    handleSplitShipment() {
      const finalSelectedDetails = this.selectedShipmentDetails.flat();
      if (finalSelectedDetails.length >= this.shipment.currentDetail.details.total) {
        this.$message.error(this.$t('customerService.shipment.error.noShipmentDetailSelected'));
        return;
      }

      if (finalSelectedDetails.length <= 0) {
        this.$message.error(this.$t('customerService.shipment.error.allShipmentDetailSelected'));
        return;
      }

      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store
        .dispatch('shipment/split', {
          shipmentId: this.shipmentId,
          shipmentDetailIds: finalSelectedDetails
        })
        .then((response) => {
          this.$message.success(response.message);
          this.cancelSplitShipment();
          this.filters.page = constants.TABLES.DEFAULT_PAGE;
          this.handleSearch();
        })
        .finally(() => {
          loading.close();
        });
    },
    cancelSplitShipment() {
      this.$refs.shipmentDetailSummaryTable.clearSelection();
      this.selectedShipmentDetails = [];
      this.splittingShipment = false;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">

  #details-search-summary-section {
    .show-cancelled {
      .el-form-item {
        .el-form-item__label {
          width: 50%;
          text-align: right;
          padding-right: 10px;
        }
        .el-form-item__content {
          width: 50%;
          padding-left: 10px;
          input {
            padding-left: 15px;
            font-size: inherit;
          }
        }
      }
    }
  }

  .shipment-header-vertical-center {
    th {
      .cell {
        line-height: 24px !important;
      }
    }
  }
  .details-total-units {
    text-align: left;
  }
</style>
